const OBJECT_ID_PATTERN = /^[0-9a-fA-F]{24}$/;

export function isValidObjectId(id: any) {
  return typeof id === 'string' && OBJECT_ID_PATTERN.test(id);
}
